

export default function SignInput({ _class, autoCompleteType, id, label, type, placeholder, setState}) {
  return (
    <div className={_class}>
        <label htmlFor={id}>{label}</label>
        <input id={id} type={type} placeholder={placeholder} autoComplete={autoCompleteType} onChange={(e)=>{setState(e.target.value)}}/>
    </div>
  )
}
